$(() => {
  var swiperTestimonial = new Swiper(".swiper-testimonial", {
    slidesPerView: 1,
    spaceBetween: 15,
    // pagination: {
    //   el: ".testimonial-pagination",
    //   clickable: true,
    // },
    navigation: {
      nextEl: ".testimonial-next",
      prevEl: ".testimonial-prev",
    },
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    breakpoints: {
      768: {
        // slidesPerView: 1,
        spaceBetween: 30,
      },
    },
  });

  var swiperBanner = new Swiper(".swiper-banner", {
    slidesPerView: 1,
    pagination: {
      el: ".swiper-pagination",
      dynamicBullets: true,
      clickable: true,
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    // effect: "fade",
    // creativeEffect: {
    //   prev: {
    //     shadow: true,
    //     translate: ["-120%", 0, -500],
    //   },
    //   next: {
    //     shadow: true,
    //     translate: ["120%", 0, -500],
    //   },
    // },
    // autoplay: {
    //     delay: 2500,
    //     disableOnInteraction: false,
    // },
  });

  var swiperIcons = new Swiper(".swiper-icons", {
    slidesPerView: 1,
    spaceBetween: 15,
    centerInsufficientSlides: true,
    navigation: {
      nextEl: ".btn-icon-next",
      prevEl: ".btn-icon-prev",
    },
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      992: {
        slidesPerView: 5,
        spaceBetween: 30,
      },
    },
  });

  /* Creating a new Swiper instance. */
  var swiperRichtext1 = new Swiper(".swiper-richtext--1", {
    slidesPerView: 1,
    spaceBetween: 15,
    pagination: {
      el: ".swiper-pagination-richtext--1",
      dynamicBullets: true,
      clickable: true,
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
  });

  /* Creating a new Swiper instance. */
  var swiperRichtext1 = new Swiper(".swiper-richtext--2", {
    slidesPerView: 1,
    spaceBetween: 15,
    pagination: {
      el: ".swiper-pagination-richtext--2",
      dynamicBullets: true,
      clickable: true,
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
  });

  var swiperTimeline = new Swiper(".swiper-timeline", {
    slidesPerView: 1,
    slidesPerGroupSkip: 1,
    grabCursor: true,
    keyboard: {
      enabled: true,
    },
    pagination: {
      el: ".pagination-timeline",
      dynamicBullets: true,
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        slidesPerGroup: 2,
      },
      992: {
        slidesPerView: 3,
        slidesPerGroup: 3,
      },
    },
  });
});


// WEBPACK FOOTER //
// ./resources/assets/js/modules/slider.js